import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const UniformCard = ({
  icon,
  image,
  title,
  subtitle,
  description,
  children,
  centered = true,
  elevation = 0,
  imageFit = "cover",
  aspectRatio = "auto",
  imagePadding = "0",
  sx = {},
}) => {
  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "var(--secondary-color)",
    midBlue: "#687693",
    lightGray: "#edecec",
    white: "#fff",
    textDark: "var(--text-color)",
  };

  const cardStyle = {
    height: "100%",
    borderRadius: "12px",
    backgroundColor: themeColors.white,
    border: `2px solid ${themeColors.lightGray}`,
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-8px)",
      borderColor: themeColors.primary,
      boxShadow: "0 12px 24px rgba(38, 43, 62, 0.15)",
    },
    ...sx,
  };

  return (
    <Card sx={cardStyle} elevation={elevation}>
      {image && (
        <Box
          sx={{
            height: aspectRatio === "auto" ? "200px" : "auto",
            aspectRatio: aspectRatio,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fcfdfe",
            borderBottom:
              imagePadding !== "0" ? "1px solid rgba(0,0,0,0.05)" : "none",
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: imageFit,
              padding: imagePadding,
              transition: "transform 0.4s ease",
            }}
            className="card-image-hover"
          />
        </Box>
      )}
      <CardContent
        sx={{
          padding: "30px",
          textAlign: centered ? "center" : "left",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          "&:last-child": { paddingBottom: "30px" },
        }}
      >
        {icon && (
          <Box
            sx={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: centered ? "center" : "flex-start",
              color: themeColors.primary,
            }}
          >
            {icon}
          </Box>
        )}

        {title && (
          <Typography
            variant="h5"
            sx={{
              color: themeColors.textDark,
              fontWeight: 700,
              marginBottom: "10px",
              fontFamily: "'Roboto Slab', serif",
              fontSize: "1.25rem",
              lineHeight: 1.4,
            }}
          >
            {title}
          </Typography>
        )}

        {subtitle && (
          <Typography
            sx={{
              color: themeColors.primary,
              fontSize: "0.875rem",
              fontWeight: 600,
              marginBottom: "15px",
              fontFamily: "'Roboto Slab', serif",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            {subtitle}
          </Typography>
        )}

        {description && (
          <Typography
            sx={{
              color: "var(--text-color)",
              lineHeight: 1.7,
              fontSize: "1rem",
              textAlign: centered ? "center" : "justify",
            }}
          >
            {description}
          </Typography>
        )}

        {children && (
          <Box sx={{ marginTop: description ? "20px" : 0 }}>{children}</Box>
        )}
      </CardContent>
    </Card>
  );
};

export default UniformCard;
